import { gql } from 'urql'

// Bumps seen_count to the number of certificates acknowledged so far, so a later
// new certificate can re-trigger the pop-up.
export const INSERT_SUBMISSION_OF_KNOWLEDGE_HUB_CERTIFICATE_SPLASH_SCREEN = gql`
  mutation InsertSubmissionOfKnowledgeHubCertificateSplashScreen(
    $profileId: uuid!
    $seenCount: Int!
  ) {
    insert_submission_of_splash_screens_one(
      object: {
        profile_id: $profileId
        splash_screen: KNOWLEDGE_HUB_CERTIFICATE
        seen_count: $seenCount
      }
      on_conflict: {
        constraint: submission_of_splash_screens_splash_screen_profile_id_key
        update_columns: [seen_count]
      }
    ) {
      id
      seen_count
    }
  }
`
